import { FatalErrorCommand } from "slotworks/commands/error/fatal-error-command";
import settingsModel from "slotworks/model/settings/settings-model";

class Currency {

    public symbolDisplay: "symbol" | "code";
    public credits: boolean = false;
    public creditRatio: number = 1;

    private currency: string = "GBP";
    private locale: string = "en";
    private decimalSeparator: string;
    private isCryptoCurrency: boolean;

    private currencyDisplay: string = "";

    /**
     * Shortcut for configuring all currency options
     *
     * @param locale {string}
     * @param currency {string}
     * @param symbolDisplay {"symbol"|"code"}
     * @param credits {boolean}
     * @param creditRatio {number}
     */
    public configure(locale: string, currency: string, symbolDisplay: "symbol" | "code", credits: boolean = null, creditRatio: number = 1 ,isCryptoCurrency:boolean = false) {
        this.locale = locale;
        this.currency = currency;
        if(settingsModel.socialSweepstakes && !settingsModel.isCurrencyInAvailableSocialCurrencies(this.currency)) {
            FatalErrorCommand("Invalid social currency! Please close the window and contact us.");
            throw new Error("Invalid social currency!");
        }
        this.symbolDisplay = symbolDisplay;
        if (credits !== null) {
            this.credits = credits;
        }
        this.creditRatio = creditRatio;
        this.isCryptoCurrency = isCryptoCurrency;

        const n = 1.1;
        this.decimalSeparator = n.toLocaleString(this.locale).substring(1, 2);
        if(settingsModel.socialSweepstakes) {
            this.currencyDisplay = this.currency.replace(/\./g, "");
        }
    }

    /**
     * Formats a number to the currency as configured
     *
     * @param value {number}
     * @param trailingDecimals {boolean}
     * @param forceCreditMode {boolean}     Specify true to format as credits or false to format as currency, regardless of current configuration
     * @return {string}
     */
    public format(value: number, trailingDecimals: boolean = true, forceCreditMode?: boolean, removeSign:boolean = false, trailingDecimalsOnCounting: boolean = false): string {

        const creditsValue = Math.round(value / this.creditRatio);

        // Model always stores smallest unit (cents, pence etc), and currency should be displayed in pounds/dollars etc
        value /= 100;

        const format: Intl.NumberFormatOptions = {
        };

        const formatAsCredits = (this.credits || forceCreditMode === true) && forceCreditMode !== false;

        if (formatAsCredits) {
            format.style = "decimal";
            format.minimumFractionDigits = 0;
            format.maximumFractionDigits = 0;
            value = creditsValue;
        } else {
            format.style = "currency";
            if(  this.isCryptoCurrency){
                format.minimumFractionDigits = 3;
            }
            else {
                format.minimumFractionDigits = 2;
            }

            if(settingsModel.socialSweepstakes) {
                // format as number
            } else {
                // format default
                format.currency = this.currency;
            }
            format.currencyDisplay = this.symbolDisplay;
        }

        let formatted = (removeSign || settingsModel.socialSweepstakes) ? value.toLocaleString(this.locale, { ...format, style: 'decimal' }) : value.toLocaleString(this.locale, format);

        // Final safeguard against floating point errors
        formatted = this.fixFloatingPointError(formatted);

        if(trailingDecimalsOnCounting && settingsModel.removeTrailingDecimals && settingsModel.socialSweepstakes) {
            formatted = formatted.split(this.decimalSeparator)[0];
        }
        if (!trailingDecimals || settingsModel.removeTrailingDecimals) {
            formatted = formatted.replace(`${this.decimalSeparator}00`, "");
        }
		 if(this.locale=='ja'){
           formatted= formatted.replace('元','CN¥');
        }
        if(settingsModel.socialSweepstakes && !removeSign) {
            formatted = "".concat(this.currencyDisplay, " ", formatted);
        }

        return formatted;
    }

    public fixFloatingPointError(s: string) {
        const decimalPosition = s.indexOf(this.decimalSeparator);

        if (decimalPosition > -1) {
            if( this.isCryptoCurrency){
                const firstHalf = s.slice(0, decimalPosition + 4);
                const secondHalf = s.slice(decimalPosition + 4).replace(/\d/gi, "");
                s = firstHalf + secondHalf;
            }
            else{
                const firstHalf = s.slice(0, decimalPosition + 3);
                const secondHalf = s.slice(decimalPosition + 3).replace(/\d/gi, "");
                s = firstHalf + secondHalf;
            }

        }

        return s;
    }

    /**
     * Report the currently used currency
     */
    public getCurrency() {
        return this.currency;
    }
}

export default new Currency();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/i18n/currency.ts